// Independent page composition for Business Data Aggregation.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function DataAggregationPage({ service }) {
  return h(PageFrame, { service, tone: 'wide', hero: diagram(service, 'bridge') },
    section('Protect the connections the business relies on', split(context(service), scope())),
    section('Plan the transition, verify the result', split(scenario(service), deliverables(service, 'rows')), { theme: 'ai-wash' }),
    section(null, answer(service), { className: 'ai-narrow-section' })
  );
};
